function checkSpecialChars(val) {
  const hasSpace = val.includes(' '),
    format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/,
    hasSpecial = format.test(val);

  return hasSpace || hasSpecial;
}

export default checkSpecialChars;
